import { render, staticRenderFns } from "./MobileMenuSectionListItem.vue?vue&type=template&id=0bab8f08&lang=html&"
import script from "./MobileMenuSectionListItem.vue?vue&type=script&lang=js&"
export * from "./MobileMenuSectionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bab8f08')) {
      api.createRecord('0bab8f08', component.options)
    } else {
      api.reload('0bab8f08', component.options)
    }
    module.hot.accept("./MobileMenuSectionListItem.vue?vue&type=template&id=0bab8f08&lang=html&", function () {
      api.rerender('0bab8f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileMenuComponents/MobileMenuSectionListItem.vue"
export default component.exports